import { css, Global } from "@emotion/react";

const global = css`
    * {
        margin: 0;
        padding: 0;
        font-family: "Pretendard";
        border: none;
        box-sizing: border-box;
        ::-webkit-scrollbar {
            display: none;
        }
    }

    *::before,
    *::after {
    }

    h2 {
        font-size: 60px;
    }

    h3 {
        font-size: 52px;
    }

    h4 {
        font-size: 40px;
    }

    h5 {
        font-size: 32px;
    }

    h6 {
        font-size: 24px;
    }

    ul,
    li {
        list-style: none;
    }

    p {
        line-height: 1.5;
    }
    html,
    body {
        height: 100%;
        overflow: hidden;
    }
    section {
        max-width: 1920px !important;
        width: 100%;
        box-sizing: border-box;
        padding: 144px 0;
        margin: 0 auto;

        @media (max-width: 1280px) {
            padding: 80px 0;
        }
        @media (max-width: 768px) {
            padding: 40px 0;
        }
    }

    button {
        background: none;
        border-style: none;
    }
`;

const GlobalStyles = () => {
    return <Global styles={global}></Global>;
};

export default GlobalStyles;
